import { createInjectionState } from '@vueuse/core'
import { isNil } from 'lodash-es'
import { computed, type MaybeRefOrGetter, unref, useAttrs } from 'vue'

const [useProvideReadOnly, useInjectReadOnly] = createInjectionState(
  (isReadOnly: MaybeRefOrGetter<boolean>) => {
    return {
      providedReadOnly: computed(() => !!unref(isReadOnly)),
    }
  },
  { injectionKey: Symbol('isReadOnlyKey') }
)

function useReadOnly() {
  const attrs = useAttrs()
  const injectedState = useInjectReadOnly()

  const isReadOnly = computed(() => {
    // First check component-specific attrs
    if (!isNil(attrs.readonly)) return !!attrs.readonly
    if (!isNil(attrs.disable)) return !!attrs.disable

    // Then check provided readonly state
    if (injectedState) {
      return injectedState.providedReadOnly.value
    }

    // Default to false
    return false
  })

  return { isReadOnly }
}

export { useProvideReadOnly, useReadOnly }
